export const MENTIONS_REGEX = /@\(\d+\)/g;
